import { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, InputAdornment, IconButton, useMediaQuery } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import { login } from '../api/api';
import { saveToken } from '../util/jwtToken';
import { useToast } from '../components/ToastContext';
import { useAppContext } from '../context/AppContext';

const LoginPage = () => {
  const { setIsLoggedIn } = useAppContext();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const { showToast } = useToast();

  const handleLogin = (e) => {
    e.preventDefault();

    const data = {
      username,
      password,
    };

    login(data)
      .then((data) => {
        setIsLoggedIn(true);
        saveToken(data.access_token);
      })
      .catch(() => showToast('Invalid credentials', 'error'));
  };

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" bgcolor="#f0f2f5">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          boxShadow: '0px 0px 27.4px 0px #00000026',
          border: '12px solid #F8FFFB',
          borderRadius: 4,
          ...(isMobile && { margin: 2 }),
        }}
      >
        <Typography fontSize={34} variant="h5" align="left" color="#02331B">
          Login
        </Typography>
        <Typography color="#6D6D6D" variant="span" align="center" gutterBottom>
          Enter your email & password to access the Skroutz Dashboard
        </Typography>
        <form onSubmit={handleLogin}>
          <Box sx={{ my: 3 }}>
            <TextField
              required
              label="Username"
              variant="outlined"
              fullWidth
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              required
              type={showPassword ? 'text' : 'password'}
              label="Password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={toggleShowPassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            sx={{ mt: 2, backgroundColor: 'success.dark', '&:hover': { backgroundColor: 'success' } }}
          >
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginPage;
